// filepath: /C:/Users/nitis/Desktop/uii/client/src/components/auth/Logout.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Remove the token from local storage
        localStorage.removeItem('token');
        // Set the logout notification message
        localStorage.setItem('notification', 'Successfully Logged Out!');
        // Redirect to the login page
        navigate('/login');
    }, [navigate]);

    return null;
};

export default Logout;